// React
import React from "react";
import { useHistory } from "react-router-dom";

// Mui
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";

// Firebase
import { auth } from "../../../firebase/firebase";

const Unauthorized: React.FC = () => {
    const hist = useHistory();
    return (
        <div className="unauthorized__container">
            <Container maxWidth="sm">
                <Typography component="h1" variant="h2" align="center" color="textPrimary" gutterBottom>
                    Accès refusé
                </Typography>
                <Typography variant="h5" align="center" color="textSecondary" paragraph>
                    Veuillez communiquer avec votre administrateur pour obtenir les droits d'accès nécessaire.
                </Typography>
                <div className="unauthorized__buttons">
                    <Grid container spacing={2} justifyContent="center">
                        <Grid item>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    auth.signOut();
                                    hist.push("/login");
                                }}
                            >
                                Fermer
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            </Container>
        </div>
    );
};

export default Unauthorized;
